module.exports = __webpack_public_path__ + "img/first-2.ac13ee7a.webp";